(function() {
	'use strict';

	angular
		.module('as.groups')
		.controller('groupDetailMainController', groupDetailMainController);

	groupDetailMainController.$inject = ['$scope','groupDetail','$state','$http','$rootScope','$timeout','$stateParams','asMessages','$filter'];

	function groupDetailMainController($scope,groupDetail,$state,$http,$rootScope,$timeout,$stateParams,asMessages,$filter) {
		//variable

		//function bindings
		$scope.clickMessageBtn = clickMessageBtn;

		//activate
		$scope.feeds={"events":{}};
		activate();	
		$scope.heroImage = {
                // 'background': 'url(' + APP_BASE_URL + 'img/job_covers/background.jpg) center/cover no-repeat'
                'background': 'url(https://almashines.s3.dualstack.ap-southeast-1.amazonaws.com/assets/images/news/400x400/post1117_t1498905489_nalst6gEna.jpg) center/cover no-repeat'
            };
		function activate() {
			console.log('groupDetail', groupDetail);
			if(groupDetail.success == 1){
				if(groupDetail.data.tag_type == 0) {
					$state.go('inapp.group_detail.discussion',$stateParams);
					return;
				}

				if(groupDetail.data && angular.isDefined(groupDetail.data['attributes']) && angular.isDefined(groupDetail.data['attributes']['coordinators']) && groupDetail.data['attributes']['coordinators'] && groupDetail.data['attributes']['coordinators'].length>0){
					var i = groupDetail.data['attributes']['coordinators'].length;
					while (i--) {
					    if (angular.isDefined(groupDetail.data['attributes']['coordinators'][i]) && angular.isDefined(groupDetail.data['attributes']['coordinators'][i]['name']) && (!groupDetail.data['attributes']['coordinators'][i]['name'] || groupDetail.data['attributes']['coordinators'][i]['name']=='')) { 
					        groupDetail.data['attributes']['coordinators'].splice(i, 1);
					    } 
					}
				}

				$scope.group = groupDetail.data;
				// 'news_posts'=> 1,// 'events'=> 5,// 'blogs'=> 6,// 'jobs'=> 7,// 'galleries'=> 8,// 'announcements'=> 9
				// var fetch = ['events','blogs','jobs','galleries','announcements'];
				var fetch = ['events','blogs','galleries'];
				if($scope.group.attributes!= undefined && typeof($scope.group.attributes.tabs) === 'string') {
					fetch = $scope.group.attributes.tabs.split(',');
				}
				setCoordinators();
				fetch.forEach(function(feed) {
					$timeout(function(){top(feed)},10);
				});
				// console.log($scope.group);
				// setCoordinators();
			}
			else {
				// snackbar_general('No chapter found for that link',3000);
				// $state.go('inapp.chapters');
			}
			get_json();
		}

		//functions
		function srvTop(feed) {
			return function(callback) {
				top(feed,callback);
			}
		}
		function top(feed,callback) {
			var data = {
				cid : $rootScope.app_data.cid,
				tag_id: $scope.group.id
			}
			return $http.post('./chapters/getTop/'+feed,data).success(function(res) {
				if(res.success==1){
					$scope.feeds[feed] = res.data;
					$scope[feed] = res.data;
					
					if(callback && typeof(callback) === "function") {
						if(feed === 'blogs')
							callback(res.data.content);
						else
							callback(res.data);
							
					}
					as_upgrade(300);
				}
			});
		}

		function setCoordinators() {
			if($scope.group.attributes != undefined && typeof($scope.group.attributes.coordinators) === 'object') {
				$scope.coordinators = $scope.group.attributes.coordinators.sort(function(a,b) {
					return a.order-b.order;
				});
				$scope.coordinators = $scope.coordinators.map(function (coord) {
					coord.errsrc = $rootScope.api_base+"institutes/profile_pic_default?cid="+$rootScope.app_data.data.cid;
					return coord;
				});
			}
		}

		function fetchFollowers(callback) {
			$http.post('./tags/followers',{tag_id:$scope.group.id,stream:1}).success(function(res) {
				console.log('tagfollowctrl', res);
				if(res.success == 1) {
					if(callback && typeof(callback) === "function") {
						callback(res.data.map(function(v) {
							if(v.profile_pic && v.profile_pic.medium)
								v.photo = v.profile_pic.medium;
							else v.photo = "";
							return v;
						}));
					}
				}
			});
		}

		function clickMessageBtn(user, event) {
            var user_ = {
                name: user.name,
                uui: user.uui?user.uui:user.unique_user_id,
                uid: user.uid,
                is_authenticated: user.is_authenticated
            };
            asMessages.openSendBox(user_, event.target,null,{hideChips: true});
        }

        function get_json() {
        	console.log("$scope.coordinators",$scope.coordinators);
        	var groupMainView = {
                "commonconf": {
                    "headingClasses": "font-20 mdl-typography--font-light mdl-color-text--white",
                    "eval-cid": "$rootScope.app_data.cid",
                    "eval-userSource": "$scope.userSource",
                    "mainDivClasses": "border-box align-self-center mdl-color--grey-100",
                    "headingParent": "border-radius-2 inline-block font-20 mdl-typography--font-light mdl-color-text--white  margin-top-16 margin-bottom-8",
                    "viewMoreButtonClasses": "button-background mdl-button mdl-js-button mdl-typography--font-regular font-12 padding-lr-8 border-box"
                },
                "elementsConf": [
                {
                	"template_name": "grid",
			        "ctrlName": "asgrid",
			        "template_type": "1",
			        "tConfiguration": {
			            "grid": {
			                "d": [
			                    3,
			                    9
			                ],
			                "t": [
			                    3,
			                    5
			                ],
			                "p": [
			                    4,
			                    4
			                ]
			            },
			            "gridClasses": "change-size mdl-grid--no-spacing",
			            "gridCellClasses":["mdl-cell--order-2-phone color-white-xs"," margin-0 padding-lr-xs-0 padding-lr-16 mdl-color--white mdl-cell--order-1-phone margin-top-20"]
			        },
			        "subTemplates": {
			        	"gridIndexed": [{
			        		"placeholders": [
			        		{
			                    "template_name": "userCard",
			                    "ctrlName": "asUserCard",
			                    "template_type": "1",
			                    "tConfiguration": {
			                    	"headingClasses": "font-24 font-xs-20 font-md-22 mdl-typography--font-medium mdl-color-text--black padding-10",
								    "cardClasses": "",
			                        "textClasses": "text-justify margin-top-8 font-14 mdl-typography--font-light",
			                        "signatureClass": "font-12 mdl-color-text--grey-600",
			                        "imageClasses": "post-avatar new-icon",
			                        "customClass2":"ng-hide",
			                        "customClass1":"mdl-typography--font-medium",
			                        "singleCardInsideClasses":"flexbox flex-wrap-wrap margin-bottom-8 padding-bottom-8",
			                        "buttonText":$filter('asPortalLang')('View_More',"View More"),
								    "buttonLinkState": "inapp.profile",
			                        "convertorConfig":{
			                          "repeat_data":{
			                            "signature":["designation"]
			                          }
			                        }
			                    },
			                    "tData": {
			                       "repeat_data": {
			                            "type": "direct",
			                            "eval-value": "$scope.coordinators"
			                        },
			                        "heading": {
			                            "type": "direct",
			                            "value": $state.current.name.indexOf('inapp.chapter_')==0?$filter("asLingo")('289'):$filter('asPortalLang')('Coordinators',"Coordinators")
			                        }
			                    }
			                }
			        		]
			        	},{
			        		"placeholders": [
			        		{
		        		      "template_name": "new_templates",
		        		      "ctrlName": "eventsModularCtrl",
		        		      "template_type": "separate_events",
		        		      "tConfiguration": {
		        		        "bgColorClass": "",
		        		        "bgColorStyle": "",
		        		        "mdlCellClass": "mdl-cell--4-col mdl-cell--6-col-tablet",
		        		        "viewAllState": "^.events"
		        		      },
		        		      "tData": {
				                  "introText": {
				                    "type": "direct",
				                    "value": ""
				                  },
				                  "heading": {
				                    "type": "direct",
				                    "value": $filter('asPortalLang')('Events',"Events")
				                  },
				                  "eventData":{
					               "type": "function",
					                "value": srvTop('events')
					               }
				               }
		        		    },		        		
			        		 {
						      "template_name": "modularGallery",
						      "ctrlName": "galleryModularCtrl",
						      "template_type": "new",
						      "tConfiguration": {
						        "bgColorClass": "",
						        "bgColorStyle": "",
						        "no_gal": "3",
						        "approval_status": [1, 2],
		                        "approval_status_for_current_user": [1, 2],
		                        "imgStyle":"min-width: 260px;max-width: 260px;min-height: 214px;max-height: 214px;",
		                        "viewAllState": "^.gallery"
		                    },
						      "tData": {
			                        "introText": {
			                            "type": "direct",
			                            "value": ""
			                        },
			                        "heading": {
			                            "type": "direct",
			                            "value": $filter('asPortalLang')('Gallery',"Gallery")
			                        },
			                        "galleries":{
						               "type": "function",
						                "value": srvTop('galleries')
						            },
			                    }
						    },
			                {
							  "template_name": "new_templates",
							  "ctrlName": "asUserCard",
							  "template_type": "separate_news",
							  "tConfiguration": {
							    "bgColorClass": "",
							    "bgColorStyle": "",
							    "gridClass":"justify-content-space-between",
							    "viewAllState": "^.feed"
							  },
							  "tData": {
			                        "repeat_data":{
						               "type": "function",
						                "value": srvTop('blogs')
						            },
			                        "heading": {
			                            "type": "direct",
			                            "value": $filter('asPortalLang')('Updates',"Updates")
			                        },
			                        "showViewAllAfter":3
			                    }
							},{
			                    "template_name": "userCard",
			                    "ctrlName": "asUserCard",
			                          "template_type": "chapterMember",
								      "tConfiguration": {
								        "buttonLinkState": "inapp.profile",
								        "degreeShow": "1",
								        "departmentShow": "1",
								        "specializationShow": "1",
								        "instituteShow": "1",
								        "yopShow": "1",
								        "convertorConfig": {
				                            "repeat_data": {
				                                "end": ["yop"],
				                                "uid": ["user_basic_id"]
				                            }
				                        },
				                        "viewAllState": "^.members",
				                        "msg":clickMessageBtn
								      },
			                    "tData": {
			                    	"repeat_data":{
						               "type": "function",
						               "value": fetchFollowers,
						            },
			                        "heading": {
			                            "type": "direct",
			                            "value": $filter('asPortalLang')('Members',"Members")
			                        }
			                    }
			                }]
			        	}]
			        }
                },
                
                ]
            };

			$scope.pageBuilderData = groupMainView;
			evalObj($scope.pageBuilderData);
			console.log("$scope.events",$scope.feeds.events);
        }

        function evalObj(obj) {
        	// console.log("cc",obj,$scope.coordinators);
            for (var key in obj) {
                var value = obj[key];

                if (typeof value === 'object') {
                    evalObj(value);
                }

                if (key.indexOf("eval-") != -1) {
                    obj[key.replace("eval-", "")] = eval(value);
                    delete obj[key];
                }

            }
        }

	}
})();
